import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

import { useNavigationHeader, useSelectedTab } from 'app/hooks';
import { Tabs } from 'app/shared-components/structure';
import config from '../../../../config.json';

const ukAppointmentTabs = [
  {
    label: 'Details',
    value: 'details',
    path: '../details',
  },
  {
    label: 'Questionnaire',
    value: 'questionnaire',
    path: '../questionnaire',
  },
  {
    label: 'Outcome',
    value: 'outcome',
    path: '../outcome',
  },
];

const canadaAppointmentTabs = [
  {
    label: 'Details',
    value: 'details',
    path: '../details',
  },
  {
    label: 'Outcome',
    value: 'outcome',
    path: '../outcome',
  },
  {
    label: 'Patient',
    value: 'patient',
    path: '../patient',
  },
  {
    label: 'Appointments',
    value: 'patient-appointments',
    path: '../patient-appointments',
  },
  {
    label: 'Orders',
    value: 'patient-orders',
    path: '../patient-orders',
  },
  {
    label: 'Medications',
    value: 'patient-medications',
    path: '../patient-medications',
  },
  {
    label: 'Messages',
    value: 'patient-messages',
    path: '../patient-messages',
  },
];

const tabsByRegion = new Map([['uk', ukAppointmentTabs], ['canada', canadaAppointmentTabs]]);

export default function AppointmentDetailsLayout({ children }) {
  const navigate = useNavigate();

  const tabs = tabsByRegion.get(config.deploymentRegion) ?? ukAppointmentTabs;

  const selectedTab = useSelectedTab(tabs);

  useNavigationHeader({
    title: 'Back to calendar',
    navigateTo: '/calendar',
  });

  function handleTabChange(event, newValue) {
    const newPath = tabs.find((tab) => tab.value === newValue)?.path;
    if (newPath) navigate(newPath, { replace: true, relative: 'path' });
  }

  return (
    <Box className="grow flex flex-col px-20 py-16 gap-16 w-1/2 min-w-[700px] m-auto overflow-y-auto scrollbar-hide">
      <Tabs
        tabs={tabs}
        selectedTab={selectedTab}
        handleChange={handleTabChange}
        sx={{ '& .MuiTab-root': { flex: 1, minWidth: 0 } }}
      />
      {children}
    </Box>
  );
}
